<ng-container *ngIf="!isEdit">
  <div
    class="cursor-pointer"
    [ngClass]="{
      'frm-color-blue-light': enabledMenu,
      'hover:frm-color-blue-light': !enabledMenu
    }"
    (click)="enabledMenu ? menu.toggle($event) : changeIsEdit()">
    <ng-template [ngTemplateOutlet]="infoTemplate"></ng-template>
  </div>
</ng-container>
<ng-container *ngIf="isEdit">
  <div
    class="frm-change-field-in-card__edit"
    crmExternalEvents
    (onClickExternal)="closeEditPanel()"
    [elements]="elements">
    <ng-template [ngTemplateOutlet]="editTemplate"></ng-template>
  </div>
</ng-container>

<p-menu
  #menu
  [popup]="true"
  [appendTo]="appendTo"
  [model]="menuItems"></p-menu>
